$(document).ready(function () {
  var coll_length = $(".customize_product-grid__item").length;
  if (
    ( window.location.pathname == "/collections" || window.location.pathname == "/collections/") && coll_length == 0
  ) {
    window.location.href = "/pages/devices";
  }
  $('#read-more-btn').on('click', function() {
        $('.additional-content').slideToggle();
        $(this).text(function(i, text){
            return text === "Read More" ? "Read Less" : "Read More";
        });
    });
  
  // setTimeout(function () {
  //   var heading = $(".okeReviews.oke-sr").html();
  //   $(".oke__heading").html(heading);
  // }, 3500);

  if ($(window).width() < 767) {
    $(".image_text_accordion").hide();
    $(".image_text_panel").click(function () {
      $(this).next(".image_text_accordion").slideToggle();
      $(".image_text_accordion").not($(this).next()).slideUp();
    });
  }
  var height = $(".pc_main_image img").height();
  $(".pc_main_video").height(height);
  setTimeout(function () {
    $(
      "fieldset.product-form__input:first-child .swatch__wrap--js input:checked"
    ).prop("checked", false);
    $("fieldset.product-form__input:first-child .swatch__wrap--js input")
      .eq(0)
      .click();
  }, 1000);

  setTimeout(function () {
    $(".price_mrp").removeClass("hidden");
  }, 500);
  $(".email__input").focus(function () {
    var checklen = $(this).parents(".newsletter  ").find(".focus_text").length;
    if (checklen == 0) {
      $(".newsletter__wrapper").append(
        `<div class="focus_text">${window.settings.input_focus_text}</div>`
      );
    }
  });
  $(".email__input").on("input", function () {
    if ($(this).val() === "") {
      $(".email__input_label").show();
    } else {
      $(".email__input_label").hide();
    }
  });

  $(".new--tab_content .tab--content").each(function () {
    var childlength = $(this).find("ul li").length;
    if (childlength > 10) {
      $(this).addClass("show-in-two-column");
    }
  });

  $(document).on("mouseenter", ".new-nav__tab", function () {
    var $el = $(this),
      $wrap = $el.closest('[id*="MegaMenu-Content-"]'),
      target = $el.attr("data-target");
    // console.log(target, "target");
    $wrap.find(".new-nav__tab").removeClass("active");
    $wrap.find(".nav-tab_color").remove();
    $wrap.find(".new--tab_content").hide();
    $el.addClass("active");
    $el.prepend("<div class='nav-tab_color'></div>");
    $(target).css("display", "flex");
  });

  $(document).on("click", ".vid_btn", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el.attr("href");
    modal(target);
  });

  $(window).on("click", function (e) {
    if (e.target.id.includes("video_modal__")) {
      modal(`#${e.target.id}`, false);
    }
    if (e.target.id === "alert-box") {
      $("#alert-box [alert-box-content]").html("");
      $("#alert-box").hide();
      clearTimeout(window.timeout);
    }
  });

  $(".click_video").each(function () {
    var $el = $(this),
      _video = $el.get(0),
      $wrp = $el.closest(".video--main"),
      $play_ico = $wrp.find(".video_play"),
      $pause_ico = $wrp.find(".video_pause");
    _video.onended = function () {
      $play_ico.show();
      $pause_ico.hide();
      // // console.log("bbb>>.>>", $play_ico, $pause_ico);
    };
  });

  $(document).on("click", ".video--main", function (e) {
    var $el = $(this),
      $click_video = $el.find(".click_video"),
      $play_ico = $el.find(".video_play"),
      $pause_ico = $el.find(".video_pause");
    if ($click_video.length) {
      var _video = $click_video.get(0);
      if (_video.paused) {
        _video.play();
        $play_ico.hide();
        $pause_ico.show();
      } else {
        _video.pause();
        $play_ico.show();
        $pause_ico.hide();
      }
    }
  });

  $(document).on("click", ".tab_link", function () {
    var $el = $(this),
      $wrp = $el.closest(".slider__tab"),
      index = $wrp.attr("data-index"),
      $next = $el.next(),
      $tab_wrp = $el.closest(".tab_link_wrap");
    if (!$el.hasClass("active")) {
      $tab_wrp.find(".tab_link").removeClass("active");
      $el.addClass("active");
      $tab_wrp.find(".tab_content").slideUp();
      $next.slideDown();
    }
    $(".image-with-text__media-item__slider").slick("slickGoTo", index);
  });

  $(".image-with-text__media-item__slider").each(function () {
    var $slider = $(this),
      options = JSON.parse($slider.attr("data-options"));
    // // console.log(options);
    $slider.slick(options);
  });

  $(".image-with-text__media-item__slider").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var $el = $(event.target),
        $tab_wrp = $el
          .closest(".image-text-tab--section")
          .find(".tab_link_wrap"),
        $tab_wrpnew = $el.closest(".featured-image_slider--section"),
        $cur_content = $(
          `.slider__tab[data-index="${nextSlide}"] .tab_content`
        ),
        $cur_link = $(`.slider__tab[data-index="${nextSlide}"] .tab_link`);
      // // console.log($tab_wrpnew, $tab_wrp);
      if ($tab_wrpnew.legth) {
        $tab_wrpnew.find(".slider__tab").hide();
        $tab_wrpnew.find(`.slider__tab[data-index="${nextSlide}"]`).fadeIn();
      } else {
        // // console.log(event, nextSlide, "<<<nextSlide", $tab_wrp);
        $tab_wrp.find(".tab_link").removeClass("active");
        $cur_link.addClass("active");
        $tab_wrp.find(".tab_content").not($cur_content).slideUp();
        $cur_content.slideDown();
      }
    }
  );

  $(document).on("click", ".tutorials_link", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el.attr("href");
    $(".tutorials_link").removeClass("active");
    $el.addClass("active");
    $(".tutorials_content--main").hide();
    $(target).show();
  });

  $(document).on("click", ".device_link", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el.attr("href");
    $(".device_link").removeClass("active");
    $el.addClass("active");
    $(".tab-content").hide();
    $(target).show();
  });
  $(document).on("click", ".discover--link[href^='#']", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el.attr("href");
    $(".discover--link").removeClass("active");
    $el.addClass("active");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 100,
      },
      2000
    );
    return false;
  });
  $(document).on("click", ".sustainability-link[href^='#']", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el.attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 80,
      },
      2000
    );
    return false;
  });
    $(".custom__reviewBlock--wrap").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
      adaptiveHeight: true,  
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
            adaptiveHeight: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
            adaptiveHeight: true,
        },
      },
    ],
  });
  $(".prd--carousel_main").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  $(".dfp_slider_enable").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".discover_menu_scroll").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".product--upsell_slider").slick({
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if ($(window).width() < 767) {
    $(".slider__mobile_slider").slick({
      dots: true,
      infinite: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  // mobile menu accordion
  $(".mob__nav-tab_text").click(function () {
    $(".mob__new--tab_content")
      .not($(this).next(".mob__new--tab_content"))
      .slideUp("slow");
    $(".mob__nav-tab_text").not($(this)).removeClass("active");
    $(this).toggleClass("active");
    $(this).next(".mob__new--tab_content").slideToggle("slow");
  });

  $(".mob_sub-menu").hide();
  $(".mob_heading").click(function () {
    $(".mob_sub-menu").not($(this).next(".mob_sub-menu")).slideUp();
    $(".mob_heading").not($(this)).removeClass("active");
    $(this).toggleClass("active");
    $(this).next(".mob_sub-menu").slideToggle();
  });

  // device page js start
  $(".mob__sublist-menu").hide();
  $(document).on("click", ".mobile_link-title", function () {
    var $el = $(this),
      $wrap = $el.closest(".list-menu");
    $wrap.find(".mob__sublist-menu").show();
  });
  $(".mob_unlist--menu").hide();
  $(".mob_list--menu").click(function (e) {
    e.preventDefault();
    $(".mob_unlist--menu").not($(this).next(".mob_unlist--menu")).slideUp();
    $(".mob_unlist--menu").not($(this)).removeClass("active");
    $(this).toggleClass("active");
    $(this).next(".mob_unlist--menu").slideToggle();
  });
  // device page js end

  $(document).on("click", ".nav-tab_text", function () {
    var $el = $(this),
      target = $el.attr("data-target");
    $el.parents(".menu-drawer__inner-submenu").addClass("mobile_has-submenu");
    $(".nav-tab_text").removeClass("active");
    $el.addClass("active");
    text = $el.find(".mon--main_link_title").text();
    $el.parents(".mob_new-nav__tab").find(".mob__ch--title").text(text);
    // // console.log(target, "target>>>");
    if (target) {
      $(target).toggle();
    }
  });
  $(document).on("click", ".mob_back_title", function () {
    var $el = $(this);
    $el
      .parents(".menu-drawer__inner-submenu")
      .removeClass("mobile_has-submenu");
    $el.parents(".mob_new--tab_content").hide();
  });

  $(window)
    .scroll(function () {
      var scrollDistance = $(window).scrollTop();

      $(".discover-featured--product_wrap")
        .closest(".shopify-section")
        .each(function (i) {
          if ($(this).position().top - 200 <= scrollDistance) {
            $(".discover--link.active").removeClass("active");
            $(".discover--link").eq(i).addClass("active");
          }
        });
    })
    .scroll();

  $(".dpa_con_main.hide").hide();
  $("#showButton").click(function () {
    $(".dpa_con_main.hide").show(300);
    $(this).parents().find(".dpa--content").addClass("open-btn");
    $("#showLess").show();
    $("#showButton").hide();
  });

  $("#showLess").click(function () {
    $(".dpa_con_main.hide").hide(150);
    $("#showButton").show();
    $(".dpa--content").removeClass("open-btn");
    $(this).hide();
  });

  $(document).on("click", ".tab_titles", function () {
    var $el = $(this),
      $wrap = $el.closest(".productpage__tabs"),
      target = $el.attr("data-target");
    $wrap.find(".tab_content").hide();
    $wrap.find(".tab_titles").removeClass("active");
    $el.addClass("active");
    $(target).show();
  });

  $(document).on("click", ".acc_tab__link", function () {
    var $el = $(this);
    $(".acc__content").not($el.next(".acc__content")).slideUp("slow");
    $(".acc_tab__link").not($el).removeClass("active");
    $el.toggleClass("active");
    $el.next(".acc__content").slideToggle("slow");
  });

  // $(document).on("click", ".acc_tab__link", function () {
  //   var $el = $(this),
  //     $next = $el.next(),
  //     $tab_wrp = $el.closest(".faq__wrap");
  //   if (!$el.hasClass("active")) {
  //     $tab_wrp.find(".acc_tab__link").removeClass("active");
  //     $el.addClass("active");
  //     $tab_wrp.find(".acc__content").slideUp();
  //     $next.slideDown();
  //   }
  // });

  // // product page Compatible products js start
  // $(document).on("click", ".product--content_wrap", function () {
  //   var $el = $(this);
  //   $el.parents(".prd-comp-prod").find(".product__media--pointer").show();
  //   $el
  //     .parents(".prd-comp-prod__main")
  //     .find(".prd-comp-prod__varinat--wrap")
  //     .slideDown();
  // });
  // $(document).on("click", ".prd--com_media", function () {
  //   var $el = $(this);
  //   $el.parents(".prd-comp-prod").find(".product__media--pointer").toggle();
  //   $el
  //     .parents(".prd-comp-prod__main")
  //     .find(".prd-comp-prod__varinat--wrap")
  //     .slideToggle();
  // });
  // // product page Compatible products js end

  $(document).on("change", ".device_select", function () {
    var $el = $(this),
      val = $el.val(),
      $selecte_opt = $el.find(":selected"),
      device_handle = $selecte_opt.attr("device-handle"),
      $wrap = $el.closest(".product__info-wrapper"),
      $radio_container = $wrap.find("#radio_container"),
      $body_varinat_container = $wrap.find("#body_varinat_container"),
      $compatible_product_container = $wrap.find(
        "#compatible-product-container"
      );
    $(".bundle-sp-s, .bundle-sp-s-2").val(device_handle);
    create_s_options();
    var ssph = $(".bundle-sp-s").val();
    if (ssph == null) {
      $(".bundle-sp-s").val("parent_product");
    }
    if ($el.closest(".main_tab--wrap").length) {
      mentain_fetured_prod();
    }
    sc_loading();
    fetch(`/products/${val}?view=ajax`)
      .then((res) => res.text())
      .then((html) => {
        var $html = $(html),
          $varinat_radio = $html.find("#variant-radios--ajax"),
          $body_variant = $html.find("#body-variant--ajax"),
          $compatible_product = $html.find("#prd-compatible--ajax"),
          current_variant = JSON.parse(
            $varinat_radio
              .find("#variant-radios-_____section_id")
              .attr("data-current_variant")
          );
        console.log(current_variant, "current_variant");
        // // console.log($varinat_radio, $body_variant, $compatible_product);
        $radio_container.html($varinat_radio.html());
        $body_varinat_container.html($body_variant.html());
        $compatible_product_container.html($compatible_product.html());
        window.onVariantChange(current_variant);
        if (history.pushState) {
          var newurl = updateQueryStringParameter(
            window.location.href,
            "device",
            device_handle
          );
          // // console.log(newurl);
          window.history.pushState({ path: newurl }, "", newurl);
        }
        sc_loading(false);
        updateCustomizeMedia();
        $(
          "fieldset.product-form__input:first-child .swatch__wrap--js input:checked"
        ).prop("checked", false);
        $("fieldset.product-form__input:first-child .swatch__wrap--js input")
          .eq(0)
          .click();
      });
  });

  function selectDevice() {
    $(".device_select").each(function () {
      var $el = $(this),
        val = $el.find("option").not(":disabled").first().attr("value"),
        device_name = getUrlVars()["device"],
        $sel_device_val = $el
          .find(`option.device__${device_name}`)
          .not(":disabled");
      // // console.log("device_name>>>", device_name, $sel_device_val);
      if ($sel_device_val.length) {
        $el.val($sel_device_val.first().attr("value")).change();
      } else {
        $el.val(val).change();
      }
    });
  }
  selectDevice();

  $(document).on("change", `.product-form__input [type="radio"]`, function () {
    var $el = $(this),
      $wrpa = $el.closest("variant-radios"),
      $w = $el.closest(".product-form__input"),
      pos = $w.attr("data-pos");
    setTimeout(function () {
      if (pos == 1) {
        $wrpa
          .find(
            '.product-form__input[data-pos="2"] .swatch__wrap--js:not(".disabled--wrap")'
          )
          .first()
          .find("input")
          .click();
      }
    }, 0);
  });

  $(document).on("click", ".seleced_body_clr", function () {
    var $el = $(this),
      $wrap = $el.closest(".body_color_selection"),
      $cnt = $wrap.find(".body_color--wrap");
    $el.toggleClass("active");
    $cnt.slideToggle();
  });
  $(document).on("click", ".bc_option_li", function () {
    var $el = $(this),
      $wrap = $el.closest(".body_color_selection"),
      $cnt = $wrap.find(".body_color--wrap"),
      img_src = $el.attr("data-image-url"),
      $seleced_body_clr = $wrap.find(".seleced_body_clr");
    // // console.log("data-image-url>>", img_src, $cnt);
    $seleced_body_clr.html($el.html());
    $wrap.find(".bc_option_li").removeClass("active");
    $el.addClass("active");
    $seleced_body_clr.toggleClass("active");
    $cnt.slideToggle();
    updateCustomizeMedia();
  });

  function slickMediaInit() {
    // if(!$(".pc_tmain_images").length || !$(".pc_thumbnails").length){return}
    if ($(".pc_tmain_images").hasClass("slick-initialized")) {
      try {
        $(".pc_tmain_images").slick("refresh");
      } catch (er) {}
    } else {
      $(".pc_tmain_images").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
    if ($(".pc_thumbnails").hasClass("slick-initialized")) {
      try {
        $(".pc_thumbnails").slick("refresh");
      } catch (er) {}
    } else {
      $(".pc_thumbnails").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }
  }
  slickMediaInit();

  $(".pc_tmain_images").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var $slick = $(event.target),
        $active_slide = $slick.find(".slick-slide.slick-current.slick-active"),
        $wrap = $slick.closest(".product__media-wrapper"),
        media_id = $active_slide.attr("media-id");
      // console.log(media_id, "<<< media_id");
      $wrap.find(`.pc_thumnails_wrap .pc_thumbnail `).removeClass("active");
      $wrap
        .find(`.pc_thumnails_wrap #pc_thumb_${media_id}_wrap`)
        .addClass("active");
    }
  );

  $(document).on("change", ".input_variant__extra", function () {
    var $el = $(this),
      name = $el.attr("name"),
      $group = $(`input:checkbox[name="${name}"].input_variant__extra`);
    $group.not(this).prop("checked", false);
    var $wrap = $el.closest(".product-form__input"),
      $main_wrap = $el.closest(".prd-comp-prod__main"),
      $img_tag = $main_wrap.find(".prd--main_image"),
      $v_title = $main_wrap.find(".variant_title"),
      $checked = $wrap.find(".input_variant__extra:checked"),
      customize_img_url = $checked.attr("data-customize-src"),
      data_src = $checked.attr("data-src"),
      data_for = $checked.attr("data-for"),
      $content = $main_wrap.find(".prd-comp-prod__varinat--wrap"),
      $pointer = $main_wrap.find(".product__media--pointer");

    if (!$checked.length) {
      $v_title.html("");
      if ($main_wrap.hasClass("active")) {
        $main_wrap.toggleClass("active");
        $pointer.toggle();
        $content.slideToggle();
      }
    } else {
      $v_title.html($checked.val());
    }
    $img_tag.attr("src", data_src);
    updateCustomizeMedia();
  });

  $(document).on("click", ".prd-comp-prod", function (e) {
    var $el = $(this),
      $event = $(e.target),
      $wrap = $el.closest(".prd-comp-prod__main"),
      $pointer = $wrap.find(".product__media--pointer"),
      $input_variant__extra = $wrap.find(".input_variant__extra"),
      $content = $wrap.find(".prd-comp-prod__varinat--wrap"),
      eventOnContent =
        $event.hasClass("product--content_wrap") ||
        $event.closest(".product--content_wrap").length;
    if (eventOnContent && $wrap.hasClass("active")) {
      return;
    }
    $wrap.toggleClass("active");
    $pointer.toggle();
    $content.slideToggle();
    $input_variant__extra.prop("checked", false);
    if ($wrap.hasClass("active")) {
      $input_variant__extra.first().prop("checked", true).change();
    } else {
      $input_variant__extra.first().change();
    }
  });

  $(document).on("click", ".pc_thumbnail", function () {
    var $el = $(this),
      $wrap = $el.closest(".pc_thumbnails"),
      media_for_id = $el.attr("media-for"),
      index = $(`#${media_for_id}_wrap`).attr("data-slick-index");
    // // console.log(index, "<<<index>>>>>>", media_for_id);
    $wrap.find(".pc_thumbnail").removeClass("active");
    $el.addClass("active");
    $(".pc_tmain_images").slick("slickGoTo", index);
  });

  $(document).on("click", ".scn__addtocart", function () {
    var $el = $(this),
      $form = $(`#${$el.attr("data-form-id")}`);
    sc_loading();
    jQuery.post({
      url: window.Shopify.routes.root + "cart/add.js",
      data: $form.serialize(),
      dataType: "json",
      success: function (cart) {
        cosole.log("success");
        // addToCartSuccess();
        window.refreshMinicart();
        window.refreshCart();
      },
      error: function (err) {
        // // console.log(err, "<<Jquery ajax");
        addToCartError(err);
      },
    });
  });

  $(document).on("click", ".sc__addtocart", function () {
    var $el = $(this),
      ids_arry = activeVariantDataByKey("id_with_availability"),
      data = [],
      items = [],
      timespan = "costomizer__" + Date.now();
    sc_loading();
    ids_arry.forEach((v) => {
      if (v.available) {
        var obj = {
          id: v.id,
          quantity: 1,
          properties: {
            __source: timespan,
          },
        };
        items.push(obj);
      }
    });
    data.push({
      items: items,
    });
    // // console.log(data[0]);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data[0]),
    })
      .then((response) => {
        if (response.ok) {
          addToCartSuccess();
          window.refreshMinicart();
          window.refreshCart();
          // $("#mini-cart").addClass('open_cart');
          // // console.log("need to update cart drawer");
          setTimeout(function () {
            $("#mini-cart").hide();
          }, 2500);
          return response.json();
        } else {
          response.json().then((text) => {
            addToCartError(text.description);
          });
          return {};
        }
      })
      .catch((error) => {
        addToCartError(error);
      });
  });

  var herader_height = $(".section-header").height();
  $(document).on("click", ".notification-close", function () {
    $(".announcement-bar-section").hide();
    setCookie("announcement", "hide", 30);
    $(".shopify-section-header-sticky").css("top", "0px");
    $(".device_menu--main").css("top", herader_height + "px");
  });
  var announcement_bar_cookie = getCookie("announcement");
  if (announcement_bar_cookie != undefined && announcement_bar_cookie != "") {
    $(".announcement-bar-section").hide();
    $(".shopify-section-header-sticky").css("top", "0px");
    $(".device_menu--main").css("top", herader_height + "px");
  } else {
    $(".announcement-bar-section").show();
  }
  var product_title_height = $(".mlc_product_title").height();
  $(".mlc_product_title").height(product_title_height);

  // bundle product page js start
  $(document).on("click", ".addon--product--main .addon--prd_img", function () {
    var _el = $(this),
      $el = _el.closest(".addon--product--main"),
      $sl = $(".bundle-sp-s option:selected"),
      $wrap = $el.closest(".addon--wrapper"),
      id = $sl.attr("data-id"),
      prv_id = $wrap.attr("addon-pos");
    // $el.toggleClass("active");
    if ($el.hasClass("active")) {
      $(`#preview-${prv_id}`).attr("data-id", id);
    } else {
      $(`#preview-${prv_id}`).attr("data-id", "null");
    }

    budleprice();
    for (var i = 1; i < 4; i++) {
      createPreveiw(i);
    }
  });

  $(document).on("click", ".pbt--tab_main", function () {
    var $el = $(this),
      target = $el.attr("data-target");
    if ($el.hasClass("disabled")) {
      return;
    }
    // console.log("target>>add", target);
    $(".pbt--tab_main").removeClass("active_pbt-tab");
    $el.addClass("active_pbt-tab");
    $(".tab_content").hide();
    $(".tab_text").hide();
    $el.find(".tab_text").show();
    $(target).show();
    madd_sliderInit();
  });

  $(document).on("click", ".stepgoto", function () {
    var $el = $(this),
      isNext = $el.hasClass("next"),
      $current_tab = $(".pbt--tab_main.active_pbt-tab"),
      $next = $current_tab.next(".pbt--tab_main"),
      $prev = $current_tab.prev(".pbt--tab_main");
    if ($next != null && isNext) {
      $next.removeClass("disabled").trigger("click");
    } else if ($prev != null) {
      $prev.removeClass("disabled").trigger("click");
    }
  });

  $(document).on("change", ".productSelectOption", function () {
    var $el = $(this),
      $selectedOption = $el.find("option:selected"),
      selectedOption = $selectedOption.val(),
      handle = $selectedOption.attr("data-handle");
    $el.find("option").removeAttr("selected");
    $selectedOption.attr("selected", "selected");
    var bundle_device_picker = $("#bundle_device_picker").html();
    // // console.log(selectedOption, "<<>>", handle);
    sc_loading();
    $(".img_grp").addClass("loading");
    fetch(`/products/${handle}?view=customize`)
      .then((r) => r.text())
      .then((html) => {
        var $prod_section = $(html).find("#MainProduct-_____section");
        $("#MainProduct-_____section").html($prod_section.html());
        $("#bundle_device_picker").html(bundle_device_picker);
        $(".bundle_main_next").remove();
        $("#compatible-product-container").after(`<div class="bundle_main_next">
            <div class="step1_next_wrap">
              <div class="step1_title_price_wrap">
                <div class="step_title">Bundle price</div>
                <div class="step1_price_wrap">
                  <div class="step1_price step_price"></div>
                  <span class="step1_cprice step_cprice"></span>
                </div>
              </div>
              <div class="step1_btn_wrap">
                <button
                  class="stepgoto next button button--full"
                >
                  Next
                </button>
              </div>
            </div>
          </div>`);
        slickMediaInit();
        selectDevice();
      });
  });

  $(document).on("click", ".pw_edit", function () {
    var $el = $(this),
      $wrap = $el.closest(".preview_detail_item"),
      step = $wrap.attr("data-step"),
      $step_tab = $(".pbt--tab--wrap .pbt--tab_main").eq(step - 1);
    // console.log(step, "<<<step>>>", $step_tab);
    $step_tab.trigger("click");
  });

  $(document).on("click", ".addtocart__bundle", function () {
    var $el = $(this),
      dis_type = $el.attr("data-dis_type"),
      dis_val = $el.attr("data-dis_val"),
      props = {
        __discount_val: dis_val,
        __discount_type: dis_type,
        __selected_device: $(".device_select option:selected").html().trim(),
      },
      ids_arr = [];
    sc_loading(true, $el);
    $(".preview_detail_item").each(function () {
      var _this = $(this),
        isHidden = _this.hasClass("hidden"),
        id = _this.attr("data-id");
      if (!isHidden) {
        ids_arr.push({ id: id, quantity: 1, properties: props });
      }
    });
    mulATC(ids_arr, $el);
  });

  $(window).scroll(function () {
    try {
      var scroll = $(window).scrollTop(),
        top = $(".pbt--tab--wrapper").offset().top,
        h = $("sticky-header.header-wrapper").height();
      if (scroll >= top - h) {
        $("sticky-header").addClass("removeSticky");
        $("body").addClass("b_sticky");
        $("sticky-header.header-wrapper").css(
          "transform",
          `translateY(-${h}px)`
        );
      } else {
        $("sticky-header").removeClass("removeSticky");
        $("body").removeClass("b_sticky");
        $("sticky-header.header-wrapper").css("transform", ``);
      }
    } catch (err) {
      console.warn(err);
    }
  });

  $(document).on("change", ".multi_prod_select", function () {
    var $el = $(this),
      val = $el.val();
    mentain_fetured_prod(val);
  });

  $(document).on(
    "change",
    ".custom_swatch__main_wrap input:radio",
    function () {
      var $el = $(this),
        $main_wrap = $el.closest(".custom_swatch__main_wrap"),
        product = JSON.parse($main_wrap.attr("data-product")),
        opt_list_cls = ".custom_swatch__options",
        pos = $(opt_list_cls).attr("option-pos"),
        variant = [],
        $dso = $main_wrap.find("[data-selected-option]"),
        $main_parent_wrap = $el.closest(".tab_content");
      variant = getVariant(product, $main_wrap, opt_list_cls);
      var value = variant[`option${pos}`],
        s_label = "";
      if (variant.available) {
        $main_parent_wrap
          .find(".step_di__action_wrap.step3_di__action_wrap .next")
          .prop("disabled", false);
        $main_parent_wrap
          .find(".step_di__action_wrap.step2_di__action_wrap .next")
          .prop("disabled", false);
      } else {
        s_label = '<span class="sol_sml">(Sold out)</span>';
        $main_parent_wrap
          .find(".step_di__action_wrap.step3_di__action_wrap .next")
          .prop("disabled", true);
        $main_parent_wrap
          .find(".step_di__action_wrap.step2_di__action_wrap .next")
          .prop("disabled", true);
      }
      $dso.html(`${value} ${s_label}`);
      // console.log(variant, "<<<variant");
      if ($el.closest("[variant__container]").length) {
        var r = $el.closest(".addon--wrapper");
        customVariantChange(variant, "bundle-addon", r);
      } else {
        customVariantChange(variant, "bundle");
      }
    }
  );

  // bundle product page js End
}); //ready

function setDefaultSwatch(_this) {
  var $el = _this || $(".custom_swatch__main_wrap input:radio"),
    $main_wrap = $el.closest(".custom_swatch__main_wrap"),
    product = JSON.parse($main_wrap.attr("data-product")),
    opt_list_cls = ".custom_swatch__options",
    variant = [];
  variant = getVariant(product, $main_wrap, opt_list_cls);
  // console.log(variant, "<<<variant");
  if ($el.closest("[variant__container]").length) {
    var r = $el.closest(".addon--wrapper");
    customVariantChange(variant, "bundle-addon", r);
  } else {
    customVariantChange(variant, "bundle");
  }
}

function getVariant(product = "", $main = "", list = "") {
  if (product == "" || $main == "" || list == "") {
    return;
  }
  var options = [],
    variants = product.variants,
    variant = [];
  $main.find(list).each(function () {
    var $el = $(this),
      $radio = $el.find(":input:radio:checked");
    options.push($radio.val());
  });
  if (options.length == 1) {
    variant = variants.filter((variant) => variant.option1 == options[0]);
  } else if (options.length == 2) {
    variant = variants.filter(
      (variant) =>
        variant.option1 == options[0] && variant.option2 == options[1]
    );
  } else {
    variant = variants.filter(
      (variant) =>
        variant.option1 == options[0] &&
        variant.option2 == options[1] &&
        variant.option3 == options[2]
    );
  }
  return variant[0];
}

function customVariantChange(variant, filter = "", $wrap = "") {
  // console.log(variant)
  if (!variant) {
    return;
  }
  switch (filter) {
    case "bundle":
      var $mwr = $("[multi--addon_wrapper-main]");
      $mwr.attr("data-id", variant.id);
      $mwr.attr("data-price", variant.price);
      $(`#preview-2`).attr("data-id", variant.id);
      $(`#preview-2`).attr("data-price", variant.price);
      $(".multi--addon_wrapper-main")
        .find(".product__media-main img")
        .first()
        .attr("src", variant.featured_image.src);
      $(".multi--addon_wrapper-main")
        .find(".product__thumbnails-main img")
        .first()
        .attr("src", variant.featured_image.src);
      $(".mp_price").html(
        `${Shopify.formatMoney(variant.price, Shopify.money_format)}`
      );
      $(".mp_subtitle").html(variant.title);
      budleprice();
      for (var i = 1; i < 4; i++) {
        createPreveiw(i);
      }
      break;
    case "bundle-addon":
      var $mwr = $("[variant__container]"),
        prv_id = $wrap.attr("addon-pos"),
        $sl = $wrap.find(".bundle-sp-s option:selected");
      $mwr.attr("data-id", variant.id);
      $mwr.attr("data-price", variant.price);
      $(`#preview-${prv_id}`)
        .attr("data-id", variant.id)
        .attr("data-price", variant.price);
      $sl.attr("data-id", variant.id).attr("data-price", variant.price);
      $wrap
        .find(".prd--price")
        .html(`${Shopify.formatMoney(variant.price, Shopify.money_format)}`);
      $wrap.find(".prd--variant").html(variant.title);
      $wrap
        .find(".addon--prd_img img")
        .attr("src", variant.featured_image.src)
        .attr("srcset", variant.featured_image.src);
      budleprice();
      for (var i = 1; i < 4; i++) {
        createPreveiw(i);
      }
      break;
    default:
  }
}

// $(".product__media-main").on(
//   "afterChange",
//   function (event, slick, currentSlide, nextSlide) {
//     var $slick = $(event.target),
//       $active_slide = $slick.find(".slick-slide.slick-current.slick-active"),
//       $wrap = $slick.closest(".product__media-wrapper"),
//       index = $active_slide.attr("data-slick-index");
//     $wrap.find(`.product__thumbnails-main .t-img`).removeClass("active");
//     $wrap
//       .find(`.t-img[data-slick-index="${index}"]`)
//       .addClass("active");
//   }
// );

function madd_sliderInit() {
  setTimeout(function () {
    if ($(".product__media-main").hasClass("slick-initialized")) {
      try {
        $(".product__media-main").slick("refresh");
      } catch (er) {}
    } else {
      $(".product__media-main").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        // asNavFor: ".product__thumbnails-main",
      });
    }
    if ($(".product__thumbnails-main").hasClass("slick-initialized")) {
      try {
        $(".product__thumbnails-main").slick("refresh");
      } catch (err) {}
    } else {
      $(".product__thumbnails-main").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        // asNavFor: ".product__media-main",
        dots: false,
        infinite: false,
      });
    }
  }, 0);
}

$(document).on("click", ".t-img", function () {
  var $el = $(this),
    $wrap = $el.closest(".product__thumbnails-main"),
    index = $el.attr("data-slick-index");
  // // console.log(index, "<<<index>>>>>>", media_for_id);
  $wrap.find(".t-img").removeClass("active");
  $el.addClass("active");
  $(".product__media-main").slick("slickGoTo", index);
});

try {
  var bannerHeight = $(".section--discover_banner").height();
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= bannerHeight) {
      $(".section--discover__menu").addClass("sticky_menu");
    } else {
      $(".section--discover__menu").removeClass("sticky_menu");
    }
  });
} catch (error) {
  // // console.log(error);
}

function modal(target, open = true) {
  if (open) {
    $(target).show();
    $("body").addClass("modal-open");
  } else {
    $(target).hide();
    $("body").removeClass("modal-open");
    $(".banner_modal_vid video").each(function () {
      $(this).get(0).pause();
    });
  }
}

window.onVariantChange = (variant) => {
  /* START:: Customize Normal Page */
  var $sc_wrap = $("#sticky_normal_btn_wrap"),
    $atc_btn = $sc_wrap.find(".scn__addtocart");
  if (variant) {
    var id = variant.id,
      lqd_variant = window.variantss[`variant_${id}`],
      inventory_policy = lqd_variant.inventory_policy,
      inventory_quantity = lqd_variant.inventory_quantity,
      pre = false;
    if (inventory_policy === "continue" && inventory_quantity <= 0) {
      pre = true;
    } else {
      pre = false;
    }
    if (history.pushState) {
      var newurl = updateQueryStringParameter(
        window.location.href,
        "variant",
        variant.id
      );
      // // console.log(newurl);
      window.history.pushState({ path: newurl }, "", newurl);
    }

    if (variant.available) {
      $atc_btn.prop("disabled", false);
      if (pre) {
        $atc_btn.addClass("preorder");
        $atc_btn.find(".atc_text").html("Pre Order");
      } else {
        $atc_btn.removeClass("preorder");
        $atc_btn.find(".atc_text").html("Add to cart");
      }
    } else {
      $atc_btn.prop("disabled", true);
      $atc_btn.find(".atc_text").html("Sold Out");
    }
    $sc_wrap
      .find(".sc_price")
      .html(Shopify.formatMoney(variant.price, Shopify.money_format));
    $(".prd_op_price").html(
      Shopify.formatMoney(variant.price, Shopify.money_format)
    );
    if (variant.compare_at_price > variant.price) {
      $sc_wrap
        .find(".sc_cprice")
        .html(
          `<s>${Shopify.formatMoney(
            variant.compare_at_price,
            Shopify.money_format
          )}</s>`
        );
      $(".prd_cp_price").html(
        `<s>${Shopify.formatMoney(
          variant.compare_at_price,
          Shopify.money_format
        )}</s>`
      );
    } else {
      $sc_wrap.find(".sc_cprice").html("");
    }
  } else {
    $atc_btn.prop("disabled", true);
    $atc_btn.find(".atc_text").html("Unavailable");
  }
  /* END:: Customize Normal Page */

  // if (!$("body").hasClass("product-customize")) {
  //   return;
  // }
  if (!$("#check_section").val() === "customize__section_called") {
    return;
  }
  /* START:: Customize Product Page */
  var $sc_wrap = $("#sticky_customize_btn_wrap"),
    $atc_btn = $sc_wrap.find(".sc__addtocart");
  // console.log(variant, "<<<<variant");
  if (variant) {
    var $cvrsid = $("#variant-radios-_____section_id");
    $cvrsid.attr("data-selected-id", variant.id);
    updateCustomizeMedia();
    // // console.log(variant);
    if (variant.available) {
      $atc_btn.prop("disabled", false);
      if (pre) {
        $atc_btn.addClass("preorder");
        $atc_btn.find(".atc_text").html("Pre Order");
      } else {
        $atc_btn.removeClass("preorder");
        $atc_btn.find(".atc_text").html("Add to cart");
      }
    } else {
      $atc_btn.prop("disabled", true);
      $atc_btn.find(".atc_text").html("Sold Out");
    }
    updateCutomizePrice();
  } else {
    $atc_btn.prop("disabled", true);
    $atc_btn.find(".atc_text").html("Unavailable");
  }
  console.log(variant, "variantafsf");
  if (!variant.available) {
    $(".img_grp").removeClass("loading");
    $(".step1_btn_wrap .stepgoto").prop("disabled", true).html("Out of stock");
  } else {
    $(".step1_btn_wrap .stepgoto").prop("disabled", false).html("Next");
  }
  $(`#preview-1`).attr("data-id", variant.id);
  $(`#preview-1`).attr("data-price", variant.price);
  for (var i = 1; i < 4; i++) {
    createPreveiw(i);
  }
  /* END:: Customize Product Page */
};

function getUrlVars() {
  var vars = [],
    hash;
  var hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

function sc_loading(flag = true, $btn = "") {
  var $atc_btn = $(
    "#sticky_customize_btn_wrap .sc__addtocart, #sticky_normal_btn_wrap .scn__addtocart"
  );
  if ($btn != "") {
    $atc_btn = $btn;
  }
  if (flag) {
    $atc_btn.prop("disabled", true);
    $atc_btn.find(".atc_text").addClass("hidden");
    $atc_btn.find(".loading-overlay__spinner").removeClass("hidden");
  } else {
    $atc_btn.prop("disabled", false);
    $atc_btn.find(".atc_text").removeClass("hidden");
    $atc_btn.find(".loading-overlay__spinner").addClass("hidden");
  }
}

function updateCustomizeMedia() {
  console.log("updateCustomizeMedia");
  try {
    $(".pc_tmain_images, .pc_thumbnails").slick("slickGoTo", 0);
  } catch (err) {}
  $(".img_grp").addClass("loading");
  setTimeout(function () {
    var $cvrsid = $("#variant-radios-_____section_id"),
      scr_variant =
        window.customize_product[
          `variant__${$cvrsid.attr("data-selected-id")}`
        ],
      body_img = scr_variant.featured_media_url || "",
      case_img =
        $(".body_color--wrap .bc_option_li.active").attr("data-image-url") ||
        "",
      button_img = scr_variant.metafields.extra_images[0] || "",
      ring_img = scr_variant.metafields.extra_images[1] || "",
      button_img_extra =
        $('.input_variant__extra[data-for="button"]:checked').attr(
          "data-customize-src"
        ) || "",
      ring_img_extra =
        $('.input_variant__extra[data-for="camera_ring"]:checked').attr(
          "data-customize-src"
        ) || "";

    if (body_img != "") {
      $(`[image-for="media-body-image"]`).attr("src", body_img);
    }
    if (case_img != "") {
      $(`[image-for="media-case-image"]`).attr("src", case_img);
    } else {
      $('[image-for="media-case-image"]').attr("src", "");
    }

    if (button_img_extra != "") {
      $(`[image-for="media-button-image"]`).attr("src", button_img_extra);
    } else if (button_img != "") {
      $(`[image-for="media-button-image"]`).attr("src", button_img);
    } else {
      $(`[image-for="media-button-image"]`).attr("src", "");
    }
    // $('.prd-comp-prod_wrap .prd-comp-prod__main.active').length <= 1 &&

    if (button_img_extra) {
      $(`[image-for="media-button-image"]`).css("zIndex", "5");
    } else {
      $(`[image-for="media-button-image"]`).css("zIndex", "");
    }
    console.log(button_img_extra, ring_img_extra, "ring_img_extra");
    if (ring_img_extra != "") {
      $(`[image-for="media-camera-ring-image"]`).attr("src", ring_img_extra);
    } else if (ring_img != "") {
      $(`[image-for="media-camera-ring-image"]`).attr("src", ring_img);
    } else {
      $(`[image-for="media-camera-ring-image"]`).attr("src", "");
    }

    var clen = $(".customize-media").length;
    $(".customize-media")
      .one("load", function () {
        clen--;
        // // console.log(clen)
        if (clen === 0) {
          setTimeout(function () {
            $(".img_grp").removeClass("loading");
          }, 100);
        }
      })
      .each(function () {
        if (this.complete) {
          // $(_this).load();
          $(this).trigger("load");
        }
      });
  }, 1);
  updateCutomizePrice();
}

function updateCutomizePrice() {
  var $stc_atc = $("#sticky_customize_btn_wrap"),
    prices = activeVariantDataByKey("price"),
    compare_at_prices = activeVariantDataByKey("compare_at_price");

  var sum_prices = prices.reduce((a, b) => a + b, 0),
    sum_compare_at_prices = compare_at_prices.reduce((a, b) => a + b, 0);
  // // console.log(prices, compare_at_prices, sum_prices, sum_compare_at_prices);
  if (sum_compare_at_prices > sum_prices) {
    $stc_atc
      .find(".sc_cprice")
      .html(
        `<s>${Shopify.formatMoney(
          sum_compare_at_prices,
          Shopify.money_format
        )}</s>`
      );
  } else {
    $stc_atc.find(".sc_cprice").html("");
  }
  $stc_atc
    .find(".sc_price")
    .html(`${Shopify.formatMoney(sum_prices, Shopify.money_format)}`);
  if ($("#title_price_update").val() === "true") {
    $("#cus_price_contains").html(
      `<h3 class="bundle_price">${Shopify.formatMoney(
        sum_prices,
        Shopify.money_format
      )}</h3>`
    );
  }
  budleprice();
}

function activeVariantDataByKey(key = "") {
  if (key != "") {
    var $cvrsid = $("#variant-radios-_____section_id"),
      $stc_atc = $("#sticky_customize_btn_wrap"),
      scr_variant =
        window.customize_product[
          `variant__${$cvrsid.attr("data-selected-id")}`
        ],
      variant_ary = [];
    variant_ary.push(scr_variant[key]);
    $(".prd-comp-prod__main").each(function () {
      var $com_prd = $(this),
        $extra = $com_prd.find(".input_variant__extra:checked");
      if ($extra.length) {
        var v = JSON.parse($extra.attr("data-variant"));
        variant_ary.push(v[key]);
      }
    });
    return variant_ary;
  } else {
    return [];
  }
}

// set cookies
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// end cookies

function addToCartSuccess($btn = "") {
  var mgs = `<div class="a_box a_success">
      <div class="alert_icon">
        <svg
          fill="currentColor"
          height="800px"
          width="800px"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 512 512"
          xml:space="preserve"
          class="icon icon-check"
        >
          <g>
            <path d="M474.045,173.813c-4.201,1.371-6.494,5.888-5.123,10.088c7.571,23.199,11.411,47.457,11.411,72.1
              c0,62.014-24.149,120.315-68,164.166s-102.153,68-164.167,68s-120.316-24.149-164.167-68S16,318.014,16,256
              S40.149,135.684,84,91.833s102.153-68,164.167-68c32.889,0,64.668,6.734,94.455,20.017c28.781,12.834,54.287,31.108,75.81,54.315
              c3.004,3.239,8.066,3.431,11.306,0.425c3.24-3.004,3.43-8.065,0.426-11.306c-23-24.799-50.26-44.328-81.024-58.047
              C317.287,15.035,283.316,7.833,248.167,7.833c-66.288,0-128.608,25.813-175.48,72.687C25.814,127.392,0,189.712,0,256
              c0,66.287,25.814,128.607,72.687,175.479c46.872,46.873,109.192,72.687,175.48,72.687s128.608-25.813,175.48-72.687
              c46.873-46.872,72.687-109.192,72.687-175.479c0-26.332-4.105-52.26-12.201-77.064
              C482.762,174.736,478.245,172.445,474.045,173.813z"></path>
            <path d="M504.969,83.262c-4.532-4.538-10.563-7.037-16.98-7.037s-12.448,2.499-16.978,7.034l-7.161,7.161
              c-3.124,3.124-3.124,8.189,0,11.313c3.124,3.123,8.19,3.124,11.314-0.001l7.164-7.164c1.51-1.512,3.52-2.344,5.66-2.344
              s4.15,0.832,5.664,2.348c1.514,1.514,2.348,3.524,2.348,5.663s-0.834,4.149-2.348,5.663L217.802,381.75
              c-1.51,1.512-3.52,2.344-5.66,2.344s-4.15-0.832-5.664-2.348L98.747,274.015c-1.514-1.514-2.348-3.524-2.348-5.663
              c0-2.138,0.834-4.149,2.351-5.667c1.51-1.512,3.52-2.344,5.66-2.344s4.15,0.832,5.664,2.348l96.411,96.411
              c1.5,1.5,3.535,2.343,5.657,2.343s4.157-0.843,5.657-2.343l234.849-234.849c3.125-3.125,3.125-8.189,0-11.314
              c-3.124-3.123-8.189-3.123-11.313,0L212.142,342.129l-90.75-90.751c-4.533-4.538-10.563-7.037-16.98-7.037
              s-12.448,2.499-16.978,7.034c-4.536,4.536-7.034,10.565-7.034,16.977c0,6.412,2.498,12.441,7.034,16.978l107.728,107.728
              c4.532,4.538,10.563,7.037,16.98,7.037c6.417,0,12.448-2.499,16.977-7.033l275.847-275.848c4.536-4.536,7.034-10.565,7.034-16.978
              S509.502,87.794,504.969,83.262z"></path>
          </g>
        </svg>
      </div>
      <div class="alert_message">Successfully added to cart!</div>
    </div>`;
  window.refreshMinicart();
  window.refreshCart();
  if ($btn != "") {
    sc_loading(false, $btn);
  } else {
    sc_loading(false);
  }
  $("#alert-box [alert-box-content]").html(mgs);
  $("#alert-box").show();
  window.timeout = setTimeout(function () {
    $("#alert-box [alert-box-content]").html("");
    $("#alert-box").hide();
    clearTimeout(window.timeout);
  }, 1500);
}
function addToCartError(error) {
  // // console.log(error);
  var er_mgs = "";
  if (error.responseJSON != null) {
    // console.log(error.responseJSON.description);
    er_mgs = error.responseJSON.description;
  } else {
    er_mgs = error;
  }
  var mgs = `<div class="a_box a_error">
      <div class="alert_icon">
        <svg class="icon icon-error-circle" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.5-5.009c0-.867.659-1.491 1.491-1.491.85 0 1.509.624 1.509 1.491 0 .867-.659 1.509-1.509 1.509-.832 0-1.491-.642-1.491-1.509zM11.172 6a.5.5 0 0 0-.499.522l.306 7a.5.5 0 0 0 .5.478h1.043a.5.5 0 0 0 .5-.478l.305-7a.5.5 0 0 0-.5-.522h-1.655z" fill="currentColor"/></svg>
      </div>
      <div class="alert_message">${er_mgs}</div>
    </div>`;
  sc_loading(false);
  $("#alert-box [alert-box-content]").html(mgs);
  $("#alert-box").show();
  window.timeout = setTimeout(function () {
    $("#alert-box [alert-box-content]").html("");
    $("#alert-box").hide();
    clearTimeout(window.timeout);
  }, 1500);
}
$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 2500) {
    $(".banner").addClass("about_banner_move");
  } else {
    $(".banner").removeClass("about_banner_move");
  }
});
$(document).on("click", ".suggest_an_impor", function () {
  $(".suggest--form-wrap").show();
});
$(document).on("click", ".icon_close", function () {
  $(".suggest--form-wrap").hide();
});

$(document).on("click", ".icon_cross", function () {
  $(this).parents(".bundle_image--wrap").hide();
});

function createPreveiw(step = "") {
  setTimeout(function () {
    try {
      if (step == "") {
        return;
      }
      // console.log("createPreveiw call");
      var $wrp = $(`#preview-${step}`),
        $img = $wrp.find(".pw_image_cover"),
        $title = $wrp.find(".pw_title"),
        $subtitle = $wrp.find(".pw_stitles"),
        $price = $wrp.find(".pw_price");
      if (step == 1) {
        var $mtw = $(".main_tab--wrap"),
          $img_grp = $mtw.find(".img_grp"),
          title =
            $mtw.find(".product__title > h1").html() +
            " - " +
            $mtw
              .find(".device_select option:selected")
              .attr("device-handle")
              .replaceAll("-", " ")
              .replaceAll("iphone", "iPhone"),
          subtitle = "",
          price = $mtw.find(".bundle_price").html();
        // console.log($mtw.find("#radio_container [data-selected-option]"));
        $mtw
          .find("#radio_container [data-selected-option]")
          .each(function (index) {
            var o = $(this);
            if (index == 0) {
              subtitle += o.html();
            } else {
              subtitle += " / " + o.html();
            }
          });
        $img.html(`<div class="img_grp">${$img_grp.html()}</div>`);
        $title.html(title);
        $subtitle.html(subtitle);
        $price.html(price);
      } else if (step == 2) {
        var $atw = $(".multi--addon_wrapper-main");
        var title = $atw.find(".mp_title").html(),
          img_src = $atw.find(".product__media-main img").first().attr("src"),
          price = $atw.find(".mp_price").html(),
          subtitle = $atw.find(".mp_subtitle").html() || "";
        $img.html(`<img src="${img_src}"/>`);
        $title.html(title);
        $subtitle.html(subtitle);
        $price.html(price);
        $wrp.removeClass("hidden");
      } else if (step >= 3) {
        var $atw = $(`.addon--wrapper[addon-pos="${step}"]`);
        var title = $atw.find(".prd--tittle").html(),
          img_src = $atw.find(".addon_prd-img").attr("src"),
          price = $atw.find(".prd--price").html(),
          subtitle = $atw.find(".prd--variant").html();
        $img.html(`<img src="${img_src}"/>`);
        $title.html(title);
        $subtitle.html(subtitle);
        $price.html(price);
        if ($atw.find(".addon--product--main").hasClass("active")) {
          $wrp.removeClass("hidden");
        } else {
          $wrp.addClass("hidden");
        }
      }
      // i++;
    } catch (err) {
      console.warn(err);
    }
  }, 0);
}

function mulATC(ids_arry, $btn = "") {
  var items = [],
    data = [];
  ids_arry.forEach((v) => {
    if (v) {
      var obj = {
        id: v.id,
        quantity: v.quantity,
        properties: v.properties,
      };
      items.push(obj);
    }
  });
  data.push({
    items: items,
  });
  // // console.log(data[0]);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data[0]),
  })
    .then((response) => {
      window.refreshMinicart();
      window.refreshCart();
      if (response.ok) {
        addToCartSuccess($btn);
        return response.json();
      } else {
        response.json().then((text) => {
          addToCartError(text.description);
          if ($btn != "") {
            sc_loading(false, $btn);
          } else {
            sc_loading(false);
          }
        });
        return {};
      }
    })
    .catch((error) => {
      addToCartError(error);
    });
}

function budleprice() {
  var $addons = $(".addon--product--main"),
    price = 0,
    p_price =
      parseInt($(`#preview-1`).attr("data-price")) +
      parseInt($(`#preview-2`).attr("data-price")),
    in_sum_p = 0,
    $b_atc_btn = $(".addtocart__bundle");

  $addons.each(function (index) {
    var $el = $(this),
      $wrap = $el.closest(".addon--wrapper"),
      prw_id = $wrap.attr("addon-pos"),
      $sl = $wrap.find(".bundle-sp-s option:selected"),
      price = parseInt($sl.attr("data-price")),
      sl_id = $sl.attr("data-id"),
      title = $sl.attr("title");
    if ($el.hasClass("active")) {
      in_sum_p = price + in_sum_p;
      $(`#preview-${prw_id}`).attr("data-id", sl_id).attr("data-price", price);
    } else {
      $(`#preview-${prw_id}`).attr("data-id", "null").attr("data-price", 0);
    }
    $wrap.find(".prd--variant").html(title);
    $wrap
      .find(".prd--price")
      .html(`${Shopify.formatMoney(price, Shopify.money_format)}`);
  });
  var sum_p = in_sum_p + p_price;
  var sale_p_price = p_price,
    sale_sum_price = sum_p,
    dis_type = $b_atc_btn.attr("data-dis_type"),
    dis_val = $b_atc_btn.attr("data-dis_val");
  if ((dis_type = "percentage")) {
    sale_p_price = p_price - (p_price * dis_val) / 100;
    sale_sum_price = sum_p - (sum_p * dis_val) / 100;
  } else {
    sale_p_price = p_price - dis_val;
    sale_sum_price = sum_p - dis_val;
  }

  if ($(".addon--product--main.active").length) {
    if (sale_p_price < p_price) {
      $(".step_price").html(
        `${Shopify.formatMoney(sale_sum_price, Shopify.money_format)}`
      );
      $(".step_cprice").html(
        `${Shopify.formatMoney(sum_p, Shopify.money_format)}`
      );
    } else {
      $(".step_price").html(
        `${Shopify.formatMoney(sum_p, Shopify.money_format)}`
      );
      $(".step_cprice").html("");
    }
  } else {
    if (sale_p_price < p_price) {
      $(".step_price").html(
        `${Shopify.formatMoney(sale_p_price, Shopify.money_format)}`
      );
      $(".step_cprice").html(
        `${Shopify.formatMoney(p_price, Shopify.money_format)}`
      );
    } else {
      $(".step_price").html(
        `${Shopify.formatMoney(p_price, Shopify.money_format)}`
      );
      $(".step_cprice").html("");
    }
  }

  // console.log($el.hasClass("active"), sum_p, '<<')
}

function mentain_fetured_prod(ds_val = "") {
  var $main = $("[multi--addon_wrapper-main]"),
    $title = $main.find("[title-container]"),
    $media = $main.find("[media-container]"),
    $variants = $main.find("[variant-picker-container]"),
    $multi_prod_select = $(".multi_prod_select");
  $multi_prod_select.find("option").each(function () {
    var $el = $(this),
      target = $el.attr("data-target"),
      child_prod = $("." + target).val();
    if (child_prod == null) {
      $el.prop("disabled", true);
    } else {
      $el.prop("disabled", false);
    }
  });
  if (ds_val != "") {
    $multi_prod_select.val(ds_val);
  } else {
    $multi_prod_select.val(
      $multi_prod_select.find("option:not(:disabled)").first().val()
    );
  }
  var $slc_prod = $multi_prod_select.find(":selected"),
    m_target = $slc_prod.attr("data-target"),
    m_product = JSON.parse($slc_prod.attr("data-value") || "[]"),
    product = JSON.parse(
      $(`.${m_target} :selected`).attr("data-product") || "[]"
    ),
    main_media = "",
    thumb_media = "";
  // console.log(
  //   m_product,
  //   "<<<m_product>>>>",
  //   m_target,
  //   "<<<<>>>>",
  //   product,
  //   Object.prototype.toString.call(m_product) === "[object Object]"
  // );
  $title.html(
    `<h3 class="h1 mp_title">${m_product.title}</h3><div class="mp_price h3"></div><div class="mp_subtitle hidden"></div>`
  );
  m_product?.images?.forEach((image) => {
    main_media += `<img src="${image.imgURL(
      "grande"
    )}" width="100%" height="auto" loading="lazy" class="m-img"/>`;
    thumb_media += `<img src="${image.imgURL(
      "compact"
    )}" width="100%" height="auto" loading="lazy" class="t-img"/>`;
  });
  fetch(`/products/${product.handle}?view=ajax`)
    .then((res) => res.text())
    .then((html) => {
      var $html = $(html),
        // current_variant = JSON.parse(
        //   $varinat_radio
        //     .find("#variant-radios-_____section_id")
        //     .attr("data-current_variant")
        // ),
        $varinat_radio = $html.find("#variant-radios--without-script-ajax");

      $variants.html($varinat_radio.html());
      $variants
        .find(".custom_swatch__option input:radio")
        .prop("checked", false);
      $variants.find(".custom_swatch__option input:radio").first().click();
      setDefaultSwatch($variants.find(".custom_swatch__main_wrap input:radio"));
      // window.onVariantChange(current_variant);
    });

  if (m_product.images.length > 1) {
    $media.html(
      `<div class="product__media-main">${main_media}</div><div class="product__thumbnails-main">${thumb_media}</div>`
    );
  } else {
    $media.html(`<div class="product__media-main">${main_media}</div>`);
  }
  madd_sliderInit();
}

String.prototype.imgURL = function (size) {
  // remove any current image size then add the new image size
  return this.replace(
    /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
    "."
  ).replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
    return "_" + size + match;
  });
};

function create_s_options() {
  var $addons = $(".addon--product--main");
  $addons.each(function (index) {
    var $el = $(this),
      $wrap = $el.closest(".addon--wrapper"),
      prw_id = $wrap.attr("addon-pos"),
      $sl = $wrap.find(".bundle-sp-s option:selected"),
      handle = $sl.attr("data-product-handle");
    fetch(`/products/${handle}?view=ajax`)
      .then((r) => r.text())
      .then((html) => {
        var $variants = $(html).find("#variant-radios--without-script-ajax");
        $addons.find("[variant__container]").html($variants.html());
        $addons
          .find("[variant__container]")
          .find(".custom_swatch__main_wrap input:radio")
          .prop("checked", false);
        $addons
          .find("[variant__container]")
          .find(".custom_swatch__main_wrap input:radio")
          .first()
          .click();
        setDefaultSwatch(
          $addons
            .find("[variant__container]")
            .find(".custom_swatch__main_wrap input:radio")
        );
      });
  });
}

window.refreshCart = () => {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      console.log("html ", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items").getAttribute("item_count")
      );
      console.log("count ", count);
      $(".cart-count-bubble").trigger("click");
      if (count > 0) {
        $("cart-drawer").removeClass("is-empty");
        $(".drawer__inner-empty").remove();
      }
      const selectors = [
        "cart-drawer-items",
        ".cart-drawer__footer",
        ".drawer__header_wrap",
        ".cart-free-product",
      ];
      $("button.cart__checkout-button").attr("disabled", false);
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      const has_ccb = document.querySelectorAll(
        ".cart-sec .cart-count-bubble"
      ).length;
      if (has_ccb > 0) {
        document
          .querySelectorAll(".cart-count-bubble span:first-child")
          .forEach((bubble) => {
            bubble.innerHTML = count;
          });
      } else {
        document.querySelectorAll(
          ".cart-sec a"
        )[0].innerHTML += ` <div class="cart-count-bubble"><span class="ttl_item">${count}</span></div>`;
      }
      document.querySelector(".ttl_item").innerHTML = count;
      $(".cart-count-bubble").trigger("click");
    })
    .catch((e) => {
      console.error(e);
    });
};

document.querySelectorAll("summary.header__menu-item").forEach((item) => {
  item.addEventListener("click", function (event) {
    event.preventDefault();
  });
});
